import { render, staticRenderFns } from "./SubmitSummary.vue?vue&type=template&id=05006264&scoped=true&"
import script from "./SubmitSummary.vue?vue&type=script&lang=ts&"
export * from "./SubmitSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05006264",
  null
  
)

export default component.exports